(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/authorized-landing.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/authorized-landing.js');
"use strict";

const OverviewList = svs.ticket_gifts.redeem.components.OverviewList;
const SingleTicket = svs.ticket_gifts.redeem.components.SingleTicket;
const getCampaignImage = svs.ticket_gifts.utils.campaign.getCampaignImage;
const AuthorizedLanding = _ref => {
  var _vouchers$map;
  let voucherData = _ref.voucherData,
    campaign = _ref.campaign,
    history = _ref.history,
    match = _ref.match;
  if (!voucherData || !voucherData.vouchers || voucherData.vouchers.error || voucherData.vouchers.length === 1 && voucherData.vouchers[0].state !== 'ACTIVE' || voucherData.vouchers.every(voucher => dateFns.parseISO(voucher.lastValidDate) < Date.now())) {
    window.location.href = "".concat(svs.core.data.baseUrl, "?err=").concat(match.params.giftCode);
    return null;
  }
  const _ref2 = voucherData || {},
    personalMessage = _ref2.personalMessage,
    receiverName = _ref2.receiverName,
    vouchers = _ref2.vouchers,
    _ref2$personalGreetin = _ref2.personalGreeting,
    personalGreeting = _ref2$personalGreetin === void 0 ? null : _ref2$personalGreetin,
    _ref2$receiverSameAsB = _ref2.receiverSameAsBuyer,
    receiverSameAsBuyer = _ref2$receiverSameAsB === void 0 ? 0 : _ref2$receiverSameAsB;
  const tickets = (_vouchers$map = vouchers === null || vouchers === void 0 ? void 0 : vouchers.map(voucher => {
    var _ref3, _getCampaignImage, _ref4;
    const state = voucher.state,
      voucherId = voucher.voucherId,
      value = voucher.value,
      ticketPosition = voucher.ticketPosition;
    const ticketInfo = svs.ticket_gifts.chooseGameForVoucher(voucher);
    const backupTicketInfo = svs.ticket_gifts.games.find(game => game.voucherId === voucher.voucherConfigId);
    const skinId = (_ref3 = ticketInfo || backupTicketInfo) === null || _ref3 === void 0 ? void 0 : _ref3.normalizeSkinId(ticketPosition);
    return {
      ticketPrice: value,
      isRedeemed: state !== 'ACTIVE',
      giftCode: voucherId,
      img: (_getCampaignImage = getCampaignImage(campaign)) !== null && _getCampaignImage !== void 0 ? _getCampaignImage : (_ref4 = ticketInfo || backupTicketInfo) === null || _ref4 === void 0 || (_ref4 = _ref4.skins[skinId - 1]) === null || _ref4 === void 0 ? void 0 : _ref4.image,
      closed: Boolean(!ticketInfo),
      ticketName: (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name) || "".concat((backupTicketInfo === null || backupTicketInfo === void 0 ? void 0 : backupTicketInfo.name) || 'Lott', "(st\xE4ngd)"),
      availableOnline: Boolean(ticketInfo),
      voucherConfigId: voucher.voucherConfigId,
      campaign
    };
  })) !== null && _vouchers$map !== void 0 ? _vouchers$map : [];
  const isManyTickets = tickets.length > 1;
  return isManyTickets ? React.createElement(OverviewList, {
    campaign: campaign,
    history: history,
    message: personalMessage,
    personalGreeting: personalGreeting,
    receiverSameAsBuyer: receiverSameAsBuyer,
    toName: receiverName,
    vouchers: tickets
  }) : React.createElement(SingleTicket, {
    campaign: campaign,
    history: history,
    message: personalMessage,
    personalGreeting: personalGreeting,
    receiverSameAsBuyer: receiverSameAsBuyer,
    toName: receiverName,
    voucher: tickets[0]
  });
};
setGlobal('svs.ticket_gifts.redeem.components.AuthorizedLanding', AuthorizedLanding);

 })(window);